import { Component, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { AuthActions } from 'src/app/common/store/actions/auth.actions';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectAuthMessage, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { DealerEditDialogComponent } from '../dealer-edit/dealer-edit.component';
import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { DomSanitizer } from '@angular/platform-browser';
import { KeycloakAuthService } from 'src/app/auth/keycloak-auth.service';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';
import { KeepOfferDialogComponent } from 'src/app/public/keep/elements/keep-offer-dialog/keep-offer-dialog.component';

@Component({
    selector: 'app-dealer-account',
    templateUrl: './dealer-account.component.html',
    styleUrls: ['./dealer-account.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerAccountComponent implements OnInit {

  dealer = new Dealer();

  showDetails: boolean = false;

  myProfile$: Observable<Dealer>;
  authFeedback$: Observable<string>;
  
  sessionInfo = "Click to update data";

  serviceTypes = CommonBasicData.serviceTypes; 
  
  passwordRecoverForm: FormGroup = new FormGroup({
    oldPassword: new FormControl('', Validators.required),
    newPassword: new FormControl('', Validators.required),
  });


  dealerImagesFolder: FileData[] = [];

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;

  currentImage: any;

  objectSource: ObjectSource = ObjectSource.DEALER
  
  CarBusinessLine = CarBusinessLine
  TransactionRole = TransactionRole

  newContractProviderId = "";
  newContractCount = 0;

  constructor(
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog, 
    private authService: KeycloakAuthService,

    private route: ActivatedRoute) {
      this.myProfile$ = this.store.select(selectDealerProfile);
      this.authFeedback$ = store.select(selectAuthMessage);

      this.currentImageIndexSubject = new BehaviorSubject<number>(0);

    }
  
  ngOnInit(): void {

    this.myProfile$.subscribe( (dealer: Dealer) => {

      //console.log(JSON.stringify(this.authService.getLoggedUser()))
      //console.log(JSON.stringify(dealer))

      if((dealer == null || dealer.username == '') && this.authService.isLoggedIn()){
        this.dealer = new Dealer();
        
        let user = this.authService.getLoggedUser();
        console.log(JSON.stringify(user))
        this.dealer.username = user.sub;
        this.dealer.email = user.email;
        //this.dealer.fname = user.given_name;
        //this.dealer.lname = user.family_name;
        //this.store.dispatch(DealerActions.updateDealerProfileSubmit( { dlUpdates: this.dealer }));
      }
      else{
        
        this.dealer = dealer;
      }
      
    }
    );

    this.store.dispatch(DealerActions.fetchMyDealerProfileSubmit());

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getImage(i);
      }
    );
    this.currentImage = this.getImage(0);
  } 

  ngOnChanges(changes: SimpleChanges): void {
      
      const latestImagesFolder = changes['dealerImagesFolder'];
      if (latestImagesFolder != undefined) {
        if ((latestImagesFolder.currentValue?.length as number) === 1) {
          
          this.currentImageIndexSubject.next(0);
        }
      }
  
    }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getImage(i: number): any{

    if(this.dealerImagesFolder != undefined && this.dealerImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.dealerImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  prevImage(): void{
      console.log("current ="+this.currentImageIndex);
      if(this.currentImageIndex === 0 )
        this.currentImageIndex = this.dealerImagesFolder.length-1;
      else 
        this.currentImageIndex--;
      
      console.log("prev ="+this.currentImageIndex);
      this.currentImageIndexSubject.next(this.currentImageIndex);
    }
  
    nextImage(): void{
      console.log("current = "+this.currentImageIndex);
  
      if(this.currentImageIndex === this.dealerImagesFolder.length-1)
        this.currentImageIndex = 0;
      else 
        this.currentImageIndex++;
      console.log("next = "+this.currentImageIndex);
      this.currentImageIndexSubject.next(this.currentImageIndex);
    }
  
    uploadImage(carId: string, event: any, ): void {
  
      let files: File[] = event.target.files;
      console.log('file name = '+files[0].name);
  
      if(files != undefined && files.length > 0){
        this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
      }
    }
  
    selectImage(index: number): void{
      this.currentImageIndex = index;
      this.currentImageIndexSubject.next(this.currentImageIndex);
    }

  openDealerEditDialog(): void {
    
    const dialogRef = this.dialog.open(DealerEditDialogComponent, {
      //data: Object.assign(new Dealer(), this.dealer)
      data: structuredClone(this.dealer)
    });

    //console.log(this.dealer)

    dialogRef.afterClosed().subscribe((result: Dealer) => {

      //console.log('New price = '+result+ " car Id = "+carId);

      //if(this.authService.isLoggedIn()){
        //result.username = this.authService.getUserName();
      //}
      if(result != undefined ){
        //console.log(result)
        this.store.dispatch(DealerActions.updateDealerProfileSubmit( { dlUpdates: result }));

      }
        
    });

  }

  refreshMessages(){
    //this.store.dispatch(MessageActions.fetchMessagesSubmit());

  }

  submitPasswordUpdateForm(){

    this.store.dispatch(AuthActions.updatePasswordSubmit({
      oldPassword: this.passwordRecoverForm.value.oldPassword,
      newPassword: this.passwordRecoverForm.value.newPassword
    }));

  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  getCountryByCode(code: string): Country{
    return GeneralBasicData.getCountryByCode(code)!;
  }

  getRatingsTotalCount(): number{
    return AppFunctions.getArraySum(this.dealer.ratingsSummary.counts)
  }

  getServiceTypeTitle(code: string): string{
    return CommonBasicData.getServiceTypeTitle(code)!;
  }


  canAddNewKeepOffer(): boolean{
    //return (this.dealer.keepOffer !== undefined && this.dealer.keepOffer !== null);
    return true
  }

  openNewKeepOfferDialog(): void {
    
      let objectData: ObjectData = new ObjectData(this.objectSource, "", 0, CarBusinessLine.KEEP );
      //objectData.carId = this.car.carId;
  
      //console.log('prop = '+JSON.stringify(carId));
      const dialogRef = this.dialog.open(KeepOfferDialogComponent, {
         data: objectData
       });
  
    }

    openNewContractDialog(providerId: string): void{

    console.log(providerId)

    this.newContractProviderId = providerId;
    this.newContractCount++;

  }

  openJobDialog(offerId: string, jobId: string){
      
    const dialogRef = this.dialog.open(JobDialogComponent, {

      data: new ObjectData(this.objectSource, offerId, +jobId, CarBusinessLine.KEEP, "")

    });
  }

}   

  
